import React , {useEffect,useState,useRef} from 'react'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { getYear,getMonth } from "date-fns";
import { useContext } from 'react'
import AuthContext from './AuthContext';
import Axios from 'axios';
import Modals from './Modals';
import Modals_Load from './Modals_Load';
import { useHistory } from "react-router-dom";
import { parse } from 'date-fns';

const FrmProfile_en = () => {
  //455693930
  const history = useHistory();
  const modalsRef = useRef(null);
  const modalsRef_load = useRef(null);

  const {gclang} = useContext(AuthContext);
  const {gnuserid} = useContext(AuthContext);
  const {gcusername} =  useContext(AuthContext);
  const {token,settoken} = useContext(AuthContext);

  const [Qeditprofilearr,setQeditprofilearr] = useState([]);        
  const [Qeditprofile,setQeditprofile] = useState({        
    lang:gclang,
    ID_Number:gnuserid,
    LeadName:'',
    LeadNameEng:'',
    First_Name_Thai:'',
    Last_Name_Thai:'',
    First_Name_Eng:'',
    Last_Name_Eng:'',
    Birth_Date:'',    
    Sex:'',
    ID_Issue_Place:'',
    ID_Issue_Place_Eng:'',
    ID_Expiry_Date:'',    
    Email:'',  
    Address1:'',
    Address1_Eng:'',
    Telephone:'',
    MobilePhone:'',    
    Question:'',        
    AnswerQuestion:'',
    CreateAt:'',
    LastUpdate:''                  
  });

  const fn_range = (start, end, step = 1) => {
    const output = [];
    for (let i = start; i < end; i += step) {
      output.push(i);
    }
    return output;
  };

  const [countries, setCountries] = useState([]);

  const [startDate, setStartDate] = useState(new Date());
  const [expiredDate, setExpiredDate] = useState(new Date());
  //const [startDate, setStartDate] = useState('');
  //const [expiredDate, setExpiredDate] = useState('');
  //const years = fn_range(1750, getYear(new Date()) + 1, 1);  
  const years = fn_range(1750, getYear(new Date()) + 50, 1);    
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const renderCustomHeader = (date, changeYear, changeMonth) => (
    <div
      style={{
        margin: 10,
        display: "flex",
        justifyContent: "center",
      }}
    >
      <select
        value={getYear(date)}
        onChange={({ target: { value } }) => changeYear(Number(value))}
      >
        {years.map((option) => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </select>

      <select
        value={months[getMonth(date)]}
        onChange={({ target: { value } }) => changeMonth(months.indexOf(value))}
      >
        {months.map((option) => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </select>
    </div>
  );
  
  useEffect(() => {
 
    async function fetchData() { 
      
      modalsRef_load.current.fnshow();  
      //const response = await Axios.post('/insertexamreuse',addFormData,{                       
      //const response = await Axios.post('/qprofile',{'QEdittemplate':QEdittemplate,'QEdittemplatearr':QEdittemplatearr},{                     
      const response = await Axios.post('/qprofile',Qeditprofile,{                       
          'withCredentials': false,     
          headers:{
              "x-access-token": token,              
              'Cache-Control': 'no-cache',
              'Pragma': 'no-cache',
              'Expires': '0',        
            }});
          if(response.data.result === '0' || response.data.result === '-1') {            
              modalsRef.current.fnshow('ข้อความเตือน',response.data.msg,false,true);
              ////history.push('/login');
  
          }
          else{    
              
              if(response.data.length > 0){   
                  modalsRef_load.current.fnclose();            
                  let output = response.data;                                                                                                                               
                  
                  setQeditprofilearr(output); 
                  
                  setQeditprofile({
                    ...output[0] // Spread all key-value pairs from the first object in Qeditprofilearr
                  }); 

                  setQeditprofile((p) => ({...p,lang:gclang}));                       

                  const birthDate = new Date(output[0].Birth_Date);                   
                  setStartDate(birthDate);
                  
                  const ID_Expiry_Date = new Date(output[0].ID_Expiry_Date);                   
                  setExpiredDate(ID_Expiry_Date);
                  
                               
              }
              else{                                
                
                setQeditprofile((p) => ({...p,lang:gclang,ID_Number:gnuserid,LeadName:'',LeadNameEng:'',First_Name_Thai:'',Last_Name_Thai:'',First_Name_Eng:'',Last_Name_Eng:'',Birth_Date:'',Sex:'',ID_Issue_Place:'',ID_Issue_Place_Eng:'',ID_Expiry_Date:'',Email:'',  Address1:'',Address1_Eng:'',Telephone:'',MobilePhone:'',Question:'',AnswerQuestion:'',CreateAt:'',LastUpdate:''}));                       
                 
              }          
          }                                                                 
  }
    
    async function fetchData2(){

    // fetch("https://restcountries.com/v3.1/all")
    fetch("https://restcountries.com/v3.1/all?fields=name,cca2")
    .then((res) => res.json())
    .then((data) => {
      const countryList = data
        .map((country) => ({
          name: country.name.common,
          code: country.cca2,
        }))
        .sort((a, b) => a.name.localeCompare(b.name)); // Sort A-Z
        setCountries(countryList);
      })
      .catch((error) => console.error("Error:", error));


    }
           
    fetchData();      
    fetchData2();      
    

  }, [token]); 

  // ตรวจสอบค่า 
  console.log(Qeditprofile); 
  console.log(Qeditprofile.Birth_Date);
  //console.log(countries);


  const handleAddChange = async (e) =>{
    e.preventDefault();
          
    const fieldName = e.target.getAttribute('name');
    const fieldValue = e.target.value;
    
    const newQeditprofile = {...Qeditprofile }; 
    newQeditprofile[fieldName] = fieldValue;
    
    setQeditprofile(newQeditprofile);
              
  }


  const handleselsexchange = async (e) =>{
    
    e.preventDefault();  
    
    const newQeditprofile = {...Qeditprofile }; 
    newQeditprofile["Sex"] = e.target.value;
    setQeditprofile(newQeditprofile);
   
  }


  const handleselID_Issue_Placechange = async (e) =>{
    
    e.preventDefault();  
    
    const newQeditprofile = {...Qeditprofile }; 
    //newQeditprofile["ID_Issue_Place"] = e.target.value;
    newQeditprofile["ID_Issue_Place_Eng"] = e.target.value;
    setQeditprofile(newQeditprofile);
   
  }

  

  const handleselleadnamechange = async (e) =>{
    
    e.preventDefault();  
    
    const newQeditprofile = {...Qeditprofile }; 
    //newQeditprofile["LeadName"] = e.target.value;
    newQeditprofile["LeadNameEng"] = e.target.value;
    setQeditprofile(newQeditprofile);
   
  }


  const fncallback = (e,iserror) => {
    e.preventDefault(); 
    if(iserror === true)
    {
      modalsRef.current.fnclose();                                    
      history.push('/login');
    }
    else{
      modalsRef.current.fnclose();        
      //modalsRef.current.fnshow('Output','กรุณากรอกข้อมูลก่อนครับ',false,false,"1");                             
    }
    
  }
  


  const handleUpdateChange2 = (date) => {
    if (date) {
      const clonedDate = new Date(date.getTime());
  
      // Convert the date to UTC and format it as 'YYYY-MM-DD' for consistency
      const formattedBirthDate = new Date(Date.UTC(
        clonedDate.getFullYear(),
        clonedDate.getMonth(),
        clonedDate.getDate()
      ));
  
      // Set cloned date for DatePicker
      setStartDate(formattedBirthDate);
  
      // Directly set the formatted date in the state (no need to parse it again)
      setQeditprofile((prev) => ({
        ...prev,
        Birth_Date: formattedBirthDate.toISOString(), // Send the UTC date as an ISO string
      }));
    }
  };

  const handleUpdateChange2_old = (date) => {
    if (date) {
      const clonedDate = new Date(date.getTime());
      
      const formattedBirthDate = new Date(Date.UTC(
        clonedDate.getFullYear(),
        clonedDate.getMonth(),
        clonedDate.getDate()
      )).toLocaleDateString("en-GB");
  
      setStartDate(clonedDate); // Set cloned date for DatePicker
         
      const birthDateObject = parse(formattedBirthDate, 'dd/MM/yyyy', new Date());
            
      setQeditprofile((prev) => ({
        ...prev,
        //Birth_Date: formattedBirthDate,
        Birth_Date: birthDateObject,
      }));
    }
  };


  const handleUpdateChange3 = (date) => {
    if (date) {
      const clonedDate = new Date(date.getTime());  
      // Convert the date to UTC and format it as 'YYYY-MM-DD' for consistency
      const formattedExpiredDate = new Date(Date.UTC(
        clonedDate.getFullYear(),
        clonedDate.getMonth(),
        clonedDate.getDate()
      ));
  
      // Set cloned date for DatePicker
      setExpiredDate(formattedExpiredDate); // Set cloned date for DatePicker
  
      // Directly set the formatted date in the state (no need to parse it again)
      setQeditprofile((prev) => ({
        ...prev,
        ID_Expiry_Date: formattedExpiredDate.toISOString(), // Send the UTC date as an ISO string
      }));
    }
      
  };

  const handleUpdateChange3_old = (date) => {
    
    if (date) {
      const clonedDate = new Date(date.getTime());

      const formattedExpiredDate = new Date(Date.UTC(
        clonedDate.getFullYear(),
        clonedDate.getMonth(),
        clonedDate.getDate()
      )).toLocaleDateString("en-GB");
  
      setExpiredDate(clonedDate); // Set cloned date for DatePicker
   
      const ExpiredDateObject = parse(formattedExpiredDate, 'dd/MM/yyyy', new Date());

      setQeditprofile((prev) => ({
        ...prev,
        //ID_Expiry_Date: formattedExpiredDate,
        ID_Expiry_Date: ExpiredDateObject,
      }));
    }
  };

  const allowEnglishOnly = (e) => {
  const char = e.key;

  if (
    char === 'Backspace' ||
    char === 'Delete' ||
    char === 'ArrowLeft' ||
    char === 'ArrowRight' ||
    char === 'Tab'
  ) {
    return;
  }

  const engRegex = /^[A-Za-z\s]$/;

  if (!engRegex.test(char)) {
    e.preventDefault();
  }
};

  
const allowThaiOnly = (e) => {
  const char = e.key;

  // อนุญาตปุ่มควบคุม
  if (
    char === 'Backspace' ||
    char === 'Delete' ||
    char === 'ArrowLeft' ||
    char === 'ArrowRight' ||
    char === 'Tab'
  ) {
    return;
  }

  // Regex ภาษาไทย
  const thaiRegex = /^[\u0E00-\u0E7F]$/;

  if (!thaiRegex.test(char)) {
    e.preventDefault();
  }
};


  const handleUpdateChange = async (e) =>{
    //1234567890121
    e.preventDefault();    
    
    // trim() กันกรณีใส่แต่ space
    if (
      !Qeditprofile.LeadName?.trim() ||      
      !Qeditprofile.First_Name_Eng?.trim() ||
      !Qeditprofile.Last_Name_Eng?.trim()
    ) {
      alert('Please fill in all required fields (*).');
      return;
    }

    const thaiTextRegex = /^[\u0E00-\u0E7F\s]+$/;

    if (
      !thaiTextRegex.test(Qeditprofile.First_Name_Thai) ||
      !thaiTextRegex.test(Qeditprofile.Last_Name_Thai)
    ) {
      alert('ชื่อและนามสกุลภาษาไทย ต้องเป็นอักษรไทยเท่านั้น');
      return;
    }

      // 3. English only
    const engTextRegex = /^[A-Za-z\s]+$/;

    if (
      !engTextRegex.test(Qeditprofile.First_Name_Eng) ||
      !engTextRegex.test(Qeditprofile.Last_Name_Eng)
    ) {      
      alert('First name and last name must contain English letters only (A–Z).');
      return;
    }
        

    
    console.log(Qeditprofile);    

    
    const response = await Axios.post('/editprofile', Qeditprofile,{               
      'withCredentials': false,     
      headers:{
          "x-access-token": token,              
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': '0',        
    }});
    let output = response.data; 
    //console.log(output);
    
    if(output[0].issuccess === 1){
      //alert(`${output[0].msg}`);  
      modalsRef.current.fnshow('Output',`${output[0].msg}`,false,false,"1");         
      
    }
    else{
      alert(`${output[0].msg}`);
    }
                  

  }

 
  return (
    <>
    <Modals_Load ref={modalsRef_load} />
    <Modals lctitle='' lcbody='' fullscreen='false' fncallback={fncallback} ref={modalsRef} />
    <br></br>
        <div class="container mt-5">
            <h4 class="text-center mb-4">Profile</h4>
            <form autocomplete="off" class="shadow p-4 rounded bg-light">
            <div className="mb-4 row">
              <label htmlFor="staticEmail" className="col-auto col-form-label text-primary"><b>ID/Passport No:</b></label>
              <div className="col">
                <input 
                  type="text" 
                  readOnly 
                  className="form-control-plaintext" 
                  id="ID_Number" 
                  name="ID_Number" 
                  value={gnuserid} 
                />
              </div>
            </div>
          

            <div className="mb-4">
              <label htmlFor="staticPrefaceName" className="form-label"><b>Title <span style={{ color: 'red' }}>*</span></b></label>              
                  <select className="form-select" name="LeadNameEng" id="LeadNameEng"  value={Qeditprofile.LeadNameEng} onChange={handleselleadnamechange} >         
                  <option value=''>Please Select</option>
                  <option value='Mr.'>Mr.</option>
                  <option value='Ms.'>Ms.</option>
                  <option value='Mrs.'>Mrs.</option>
                  </select>                                  
            </div>
                       
            <div class="mb-4">
              <label for="staticname_eng" class="form-label"><b>First Name (English) <span style={{ color: 'red' }}>*</span></b></label>
              <input type="text" class="form-control" id="First_Name_Eng"name="First_Name_Eng" value={Qeditprofile.First_Name_Eng} onChange={handleAddChange} onKeyDown={allowEnglishOnly} />                            
            </div>

            <div class="mb-4">
              <label for="staticlastname_eng" class="form-label"><b>Last Name (English) <span style={{ color: 'red' }}>*</span></b></label>
              <input type="text" class="form-control" id="Last_Name_Eng" name="Last_Name_Eng" value={Qeditprofile.Last_Name_Eng} onChange={handleAddChange} onKeyDown={allowEnglishOnly} />
            </div>

            <div class="mb-4">         
              <label for="staticName" class="form-label"><b>First Name (Thai If Any)</b></label>                    
              <input type="text" class="form-control" id="First_Name_Thai" name="First_Name_Thai" value={Qeditprofile.First_Name_Thai} onChange={handleAddChange} onKeyDown={allowThaiOnly} />              
            </div>

            <div class="mb-4">
              <label for="staticLastName" class="form-label"><b>Last Name (Thai If Any)</b></label>              
              <input type="text" class="form-control" id="Last_Name_Thai" name ="Last_Name_Thai" value={Qeditprofile.Last_Name_Thai} onChange={handleAddChange} onKeyDown={allowThaiOnly} />
              
            </div>

            <div class="mb-4">
              <label for="staticbirthdate" class="form-label"><b>Birth Date (DD/MM/YYYY)&nbsp;&nbsp;</b></label>                
                <DatePicker
                  renderCustomHeader={({ date, changeYear, changeMonth }) =>
                    renderCustomHeader(date, changeYear, changeMonth)
                  }
                  selected={startDate}
                  onChange={handleUpdateChange2}
                  dateFormat="dd/MM/yyyy"
                  id="Birth_Date"
                  name="Birth_Date"                
                />                          
            </div>

            <div class="mb-4">
              <label for="staticSex" class="form-label"><b>Sex</b></label>        
              <select className="form-select" name="Sex" id="Sex" value={Qeditprofile.Sex} onChange={handleselsexchange} >         
              <option value=''>Please Select</option>
              <option value='M'>M</option>
              <option value='F'>F</option>              
              </select>            
            </div>

            <div class="mb-4">
              <label for="staticSex" class="form-label"><b>ID Issuing Place</b></label>              
              <select className="form-select" name="ID_Issue_Place_Eng" id="ID_Issue_Place_Eng" value={Qeditprofile.ID_Issue_Place_Eng} onChange={handleselID_Issue_Placechange} >         
                <option value=""></option>
                {countries.map((country) => (
                  <option value={country.name}>
                    {country.name}
                  </option>
                ))}
              </select>              
            </div>

            <div class="mb-4">
              <label for="staticExpireddate" class="form-label"><b>ID Expiry Date (DD/MM/YYYY)&nbsp;&nbsp;</b></label>             
                <DatePicker
                  renderCustomHeader={({ date, changeYear, changeMonth }) =>
                    renderCustomHeader(date, changeYear, changeMonth)
                  }
                  selected={expiredDate}
                  onChange={handleUpdateChange3}
                  dateFormat="dd/MM/yyyy"
                  id="ID_Expiry_Date"
                  name="ID_Expiry_Date"
                />              
            </div> 

            <div class="mb-4">
              <label for="staticEmail" class="form-label"><b>Email</b></label>              
              <input type="email" class="form-control" id="Email" name="Email" value={Qeditprofile.Email} onChange={handleAddChange} />                              
            </div>   

            <div class="mb-4">
              <label for="staticAddress" class="form-label"><b>Address</b></label>
              <textarea class="form-control" id="Address1_Eng" name="Address1_Eng" rows="4" value={Qeditprofile.Address1_Eng} onChange={handleAddChange}></textarea>              
            </div>

            <div class="mb-4">
              <label for="statictelephone" class="form-label"><b>Telephone</b></label>
              <input type="text" class="form-control" id="Telephone" name="Telephone" value={Qeditprofile.Telephone} onChange={handleAddChange} />              
            </div>

            <div class="mb-4">
              <label for="staticmobilephone" class="form-label"><b>Mobile Phone</b></label>          
              <input type="text" class="form-control" id="MobilePhone" name="MobilePhone" value={Qeditprofile.MobilePhone} onChange={handleAddChange} />          
            </div>

 
            <div className="mb-4 row">
              <label htmlFor="staticCreateat" className="col-auto col-form-label"><b>Create At:</b></label>
              <div className="col">
                <input 
                  type="text" 
                  readOnly 
                  className="form-control-plaintext" 
                  id="CreateAt" 
                  name="CreateAt" 
                  value={Qeditprofile.CreateAt} 
                />
              </div>
            </div>


            <div className="mb-4 row">
              <label htmlFor="staticadjustdate" className="col-auto col-form-label"><b>Last Update:</b></label>
              <div className="col">
                <input 
                  type="text" 
                  readOnly 
                  className="form-control-plaintext" 
                  id="LastUpdate" 
                  name="LastUpdate" 
                  value={Qeditprofile.LastUpdate} 
                />
              </div>
            </div>


            <div class="mb-4">
              <label for="staticquestionforsecurity" class="form-label"><b>Security Question</b></label>
              <input type="text" class="form-control" id="Question" name="Question"  value={Qeditprofile.Question} onChange={handleAddChange} />                            
            </div>

            <div class="mb-4">
              <label for="staticanswer" class="form-label"><b>Answer</b></label>
              <input type="text" class="form-control" id="AnswerQuestion" name="AnswerQuestion"  value={Qeditprofile.AnswerQuestion} onChange={handleAddChange} />         
            </div>

            <div class="mb-4">          
              <button className='btn btn-primary w-100' onClick={handleUpdateChange}>Update</button>            
            </div>           
        </form>           
        </div>                   
    </>
  )
}

export default FrmProfile_en



